module.exports = __webpack_public_path__ + "static/media/info_icon.f5436f04.svg";